import appConfig from 'app.config'
import { useTranslation } from 'react-i18next'

export const SetPasswordIdCheckForm = (data: any) => {
	const { t } = useTranslation()
	return {
		fieldSetName: '',
		formName: 'SetPasswordIdCheck',
		description: '',
		collapsable: false,
		visible: true,
		market: 'de',
		fullSize: true,
		col: 12,
		controls: [
			{
				controlName: 'phoneNo',
				type: 'tel', //change back to phoneNumber when formbuilder is updated
				label: t('PhoneNumber'),
				value: data.mobilePhoneNumber,
				visible: true,
				fullSize: true,
				col: 12,
				options: [
					{
						value: appConfig.country.toUpperCase(),
						label: appConfig.country.toUpperCase(),
					},
				],
				wrapperClass: 'tel-container-wrapper ' + appConfig.country, //Add this class for now when using type "tel"
				disabled: true,
			},
			{
				required: true,
				controlName: 'password',
				description: t('PasswordDescription'),
				type: 'password',
				label: t('Password'),
				visible: true,
				col: 12,
			},
			{
				required: true,
				controlName: 'repeatPassword',
				type: 'password',
				label: t('RepeatPassword'),
				visible: true,
				col: 12,
			},
		],
	}
}
